var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.media)?_c('div',{staticClass:"news-media"},_vm._l((_vm.media),function(file,index){return _c('div',{key:index,ref:`cr-${_vm.id}`,refInFor:true,staticClass:"news-media-file"},[(file.type === 'image')?_c('ImageVisor',{staticClass:"image-visor",attrs:{"file":file}}):_vm._e()],1)}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }